import { supabase } from '@/lib/supabase'

export type CommunityThreadContextType = 'opportunity' | 'analysis' | 'vision' | 'chat'

function normalizeContextId(raw: number): number | null {
  const id = Number(raw)
  if (!Number.isFinite(id) || id <= 0) return null
  return Math.floor(id)
}

export async function fetchCommunityThreadNotificationsEnabled(params: {
  contextType: CommunityThreadContextType
  contextId: number
}): Promise<boolean> {
  const id = normalizeContextId(params.contextId)
  if (!id) return false

  const { data, error } = await supabase
    .from('community_thread_subscriptions' as any)
    .select('enabled')
    .eq('context_type', params.contextType)
    .eq('context_id', id)
    .maybeSingle()

  if (error) throw error
  return Boolean((data as any)?.enabled)
}

export async function setCommunityThreadNotificationsEnabled(params: {
  contextType: CommunityThreadContextType
  contextId: number
  enabled: boolean
}): Promise<boolean> {
  const id = normalizeContextId(params.contextId)
  if (!id) return false

  const { data, error } = await supabase.rpc('set_community_thread_subscription' as any, {
    p_context_type: params.contextType,
    p_context_id: id,
    p_enabled: Boolean(params.enabled),
  })

  if (error) throw error
  return Boolean(data)
}
